/* ===== AROMAZUR v22 — fiche produit : galerie, variantes, quantite, promo ===== */
(function(){
  function $(s){return document.querySelector(s);}
  var VARIANTS=[], OPTNAMES=[], SEL=[], IMAGES=[], VIMG=false;
  var PROMO = (window.AZ_PROMO_PCT||0)/100;

  /* ===== IMAGE SELON LA VARIANTE =====
     Sur l'ancienne bulle produit de la page d'accueil, changer de contenance
     ou de finition changeait le visuel : le theme appliquait sa propre regle
     (premiere variante = premier visuel, les suivantes = deuxieme).

     En passant aux vraies fiches produit, cette regle a disparu : la fiche ne
     lisait plus que l'image rattachee a la variante dans l'admin Shopify. Sur
     les produits ou cette liaison n'a jamais ete faite — c'est le cas de la
     plupart des huiles — le visuel restait donc fige.

     On retablit le repli, mais sans jamais contredire l'admin : si au moins
     une variante du produit porte une image, c'est l'admin qui commande, du
     debut a la fin. Le repli ne s'applique qu'aux produits ou aucune liaison
     n'existe. Rattacher les images dans Shopify reste la bonne facon de
     faire, et desactive le repli d'elle-meme. */
  function imgFor(v){
    if(v && v.featured_image && v.featured_image.src) return v.featured_image.src;
    if(VIMG) return null;              /* l'admin gere : on ne devine pas */
    if(IMAGES.length < 2) return null; /* un seul visuel : rien a permuter */
    return currentIndex(v.id)===0 ? IMAGES[0] : IMAGES[1];
  }
  /* Les adresses ne sont pas comparables telles quelles : l'admin renvoie le
     fichier d'origine, le theme une version redimensionnee. On compare donc
     le nom de fichier, debarrasse du suffixe de taille. */
  function nomFichier(u){
    if(!u) return '';
    return (String(u).split('?')[0].split('/').pop()||'').replace(/_\d+x\d*(?=\.)/,'');
  }
  function syncThumb(src){
    var n=nomFichier(src), trouve=false;
    document.querySelectorAll('.pp-thumb').forEach(function(b){
      var ok = !trouve && nomFichier(b.getAttribute('data-src'))===n;
      b.classList.toggle('on', ok);
      if(ok) trouve=true;
    });
  }

  function eur(n){ return n.toFixed(2).replace('.',',')+' €'; }
  /* meme arrondi que Shopify : la remise est tronquee au centime inferieur */
  function disc(p){ var r=Math.floor(p*PROMO*100)/100; return Math.round((p-r)*100)/100; }

  /* Shopify peut deja porter la remise dans price, avec compare_at_price comme
     ancien prix. Dans ce cas il ne faut JAMAIS recalculer la promo maison. */
  function prix(v){ return Number(v&&v.price||0)/100; }
  /* Prix de reference (promo ciblee, prix deja remise dans Shopify) : ancien
     prix = prix / (1 - pct), affiche barre. Aucune remise n'est recalculee. */
  var REF=Number(window.AZ_PROMO_REF_PCT||0);
  function refPrix(p){ return (REF>0&&REF<100)?Math.round(p/(1-REF/100)*100)/100:0; }
  function compare(v){ var c=Number(v&&v.compare_at_price||0)/100; if(!(c>0)&&REF&&!isAbo()) c=refPrix(prix(v)); return c; }
  function aPrixBarreShopify(v){ var p=prix(v), c=compare(v); return p>0 && c>p; }
  function prixPaye(v){
    var p=prix(v);
    if(isAbo()) return p;
    if(aPrixBarreShopify(v)) return p;
    return PROMO>0 ? disc(p) : p;
  }

  function paint(v){
    var box=$('#ppPrice'); if(!box||!v) return;
    var p=prix(v), c=compare(v);
    if(!isAbo() && c>p){
      box.innerHTML='<s class="az-old">'+eur(c)+'</s><span class="az-new">'+eur(p)+'</span>';
    } else if(PROMO>0 && !isAbo()){
      box.innerHTML='<s class="az-old">'+eur(p)+'</s><span class="az-new">'+eur(disc(p))+'</span>';
    } else { box.textContent=eur(p); }
    var id=$('#ppVariantId'); if(id) id.value=v.id;
    var add=$('#ppAdd'), sold=$('#ppSold');
    if(add){ add.disabled=!v.available; add.textContent=v.available?'Ajouter au panier':'Indisponible'; }
    if(sold) sold.style.display=v.available?'none':'block';
    var src=imgFor(v);
    if(src){
      var img=$('#ppMainImg');
      if(img && img.getAttribute('src')!==src) img.src=src;
      syncThumb(src);
    }
    try{
      var u=new URL(window.location); u.searchParams.set('variant',v.id);
      history.replaceState({},'',u);
    }catch(e){}
  }

  function match(){
    for(var i=0;i<VARIANTS.length;i++){
      var v=VARIANTS[i], ok=true;
      for(var j=0;j<SEL.length;j++){
        var val=v['option'+(j+1)];
        if(SEL[j]!=null && val!==SEL[j]){ ok=false; break; }
      }
      if(ok) return v;
    }
    return null;
  }

  window.azSetMainImg=function(src,btn){
    var img=$('#ppMainImg'); if(img) img.src=src;
    document.querySelectorAll('.pp-thumb').forEach(function(b){b.classList.remove('on');});
    if(btn) btn.classList.add('on');
  };

  window.azSelectOption=function(btn){
    var row=btn.closest('.pp-opt');
    /* l'index fiable est celui de la ligne d'option dans le DOM */
    var idx=row?[].indexOf.call(document.querySelectorAll('.pp-opt'),row):parseInt(btn.getAttribute('data-opt-index'),10);
    if(isNaN(idx)||idx<0) idx=parseInt(btn.getAttribute('data-opt-index'),10)||0;
    var val=btn.getAttribute('data-value');
    SEL[idx]=val;
    var vals=btn.parentElement;
    if(vals) vals.querySelectorAll('.fmt').forEach(function(b){b.classList.remove('on');});
    btn.classList.add('on');
    var v=match(); if(v) paint(v);
  };

  window.azQty=function(d){
    var q=$('#ppQty'); if(!q) return;
    var n=Math.max(1,(parseInt(q.value,10)||1)+d); q.value=n;
  };


  /* ===== UN SEUL PANIER =====
     La fiche produit ecrivait dans le panier natif Shopify, la page d'accueil
     dans localStorage. Or openCheckout() vide le panier Shopify avant de
     recopier le sien : tout ajout fait depuis une fiche produit disparaissait.
     On ecrit desormais dans le meme panier que la page d'accueil. */
  var ALIAS={'package-protection':'az-protection-aromazur'};

  function isAbo(){ return /abonnement/i.test(window.AZ_PRODUCT_TITLE||document.title||''); }

  function dbHandle(h){ return ALIAS[h] || ('az-'+h); }

  function currentIndex(vid){
    for(var i=0;i<VARIANTS.length;i++){ if(String(VARIANTS[i].id)===String(vid)) return i; }
    return 0;
  }

  function feedback(n){
    var box=document.getElementById('ppAdded');
    if(!box){
      box=document.createElement('div'); box.id='ppAdded'; box.className='pp-added';
      var f=document.getElementById('ppForm'); if(f) f.parentNode.insertBefore(box, f.nextSibling);
    }
    /* Avant : un simple lien « Voir mon panier » vers /?panier=1, qui rechargeait
       entierement la page d'accueil. Le tiroir existe desormais sur toutes les
       pages (snippets/az-minicart.liquid) : on l'ouvre sur place et on propose
       les deux suites possibles au lieu d'une seule. */
    box.innerHTML='<strong>✓ Ajouté au panier</strong>'+
      '<span class="pp-added-n">'+n+' article'+(n>1?'s':'')+' dans votre panier</span>'+
      '<span class="pp-added-act">'+
      '<button type="button" class="pp-added-go" onclick="if(window.openCart)openCart();">Voir mon panier</button>'+
      '<button type="button" class="pp-added-buy" onclick="if(window.openCheckout)openCheckout();">Passer commande</button>'+
      '</span>';
    box.style.display='block';
  }

  /* Ajout natif Shopify (08/09/2026) : la variante part immediatement dans
     /cart/add.js via assets/az-cart.js. Shopify verifie le stock lui-meme et
     refuse une variante epuisee avec un message, affiche sous le bouton. */
  function addLocal(e){
    if(e) e.preventDefault();
    var vid=parseInt(($('#ppVariantId')||{}).value,10);
    var q=Math.max(1, parseInt((($('#ppQty')||{}).value)||'1',10));
    if(!vid||!window.AZCart){ return; }
    var btn=$('#ppAdd'), lab=btn?btn.textContent:'';
    if(btn){ btn.disabled=true; btn.textContent='Ajout…'; }
    AZCart.add({id:vid, quantity:q},{onError:function(m){ feedbackErr(m); }})
      .then(function(c){ feedback(c.item_count); })
      .catch(function(){})
      .then(function(){ if(btn){ btn.disabled=false; btn.textContent=lab; } });
  }
  function feedbackErr(m){
    var box=document.getElementById('ppAdded');
    if(!box){ box=document.createElement('div'); box.id='ppAdded'; box.className='pp-added'; var f=document.getElementById('ppForm'); if(f) f.parentNode.insertBefore(box, f.nextSibling); }
    box.innerHTML='<strong>Ajout impossible</strong><span class="pp-added-n">'+m+'</span>';
    box.style.display='block';
  }

  function hookForm(){
    var f=document.getElementById('ppForm');
    if(f) f.addEventListener('submit', addLocal);
  }

  function boot(){
    try{ VARIANTS=JSON.parse(($('#ppVariants')||{}).textContent||'[]'); }catch(e){ VARIANTS=[]; }
    try{ OPTNAMES=JSON.parse(($('#ppOptionNames')||{}).textContent||'[]'); }catch(e){ OPTNAMES=[]; }
    try{ IMAGES=JSON.parse(($('#ppImages')||{}).textContent||'[]'); }catch(e){ IMAGES=[]; }
    if(!VARIANTS.length) return;
    VIMG=false;
    for(var z=0;z<VARIANTS.length;z++){
      if(VARIANTS[z].featured_image && VARIANTS[z].featured_image.src){ VIMG=true; break; }
    }
    /* Variante affichee a l'ouverture.
       Sans ?variant= dans l'adresse, Shopify retient la premiere variante du
       catalogue, qui n'est pas forcement la moins chere : on arrivait sur le
       50 ml a 44 € apres avoir clique sur une carte annoncant 20 €.
       On ouvre donc sur la variante disponible la moins chere, celle du prix
       affiche sur les cartes ("des X €"). */
    var lignes=document.querySelectorAll('.pp-opt');
    var depart=null, force=null;
    try{ force=new URL(window.location).searchParams.get('variant'); }catch(e){}
    if(force){
      for(var n=0;n<VARIANTS.length;n++) if(String(VARIANTS[n].id)===String(force)) depart=VARIANTS[n];
    }
    if(!depart){
      for(var m=0;m<VARIANTS.length;m++){
        var w=VARIANTS[m];
        if(w.available===false) continue;
        if(!depart || w.price<depart.price) depart=w;
      }
    }
    if(depart) for(var o=0;o<lignes.length;o++) SEL[o]=depart['option'+(o+1)];
    lignes.forEach(function(row,i){
      var voulu=SEL[i];
      var on=null;
      if(voulu!=null) on=row.querySelector('.fmt[data-value="'+String(voulu).replace(/"/g,'\\"')+'"]');
      if(!on) on=row.querySelector('.fmt.on')||row.querySelector('.fmt');
      SEL[i]= on ? on.getAttribute('data-value') : null;
      row.querySelectorAll('.fmt').forEach(function(b){ b.classList.toggle('on', b===on); });
    });
    var v=match()||VARIANTS[0];
    paint(v);
    /* paint() a deja pose la vignette active si un visuel correspond ;
       sinon on retombe sur la premiere. */
    if(!document.querySelector('.pp-thumb.on')){
      var t=document.querySelector('.pp-thumb'); if(t) t.classList.add('on');
    }
    hookForm();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
})();
